import React from 'react';
import { withRouter } from 'react-router-dom';
import PayrollIndex from './PayrollIndex';

const PayrollIndividualIndex = () => (
    <PayrollIndex />
);

export default withRouter(PayrollIndividualIndex);
